import { render, staticRenderFns } from "./BrandBarChart.vue?vue&type=template&id=478f9e3b&"
import script from "./BrandBarChart.vue?vue&type=script&lang=js&"
export * from "./BrandBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports